import produce from 'immer';

/* ACTION 정의 */
export const GET_AUTOMESSAGE = 'GET_AUTOMESSAGE';
export const GET_AUTOMESSAGE_SUCCES = 'GET_AUTOMESSAGE_SUCCES';
export const GET_AUTOMESSAGE_FAILURE = 'GET_AUTOMESSAGE_FAILURE';

export const GET_CERTIFICATEDATA = 'GET_CERTIFICATEDATA';
export const GET_CERTIFICATEDATA_SUCCES = 'GET_CERTIFICATEDATA_SUCCES';
export const GET_CERTIFICATEDATA_FAILURE = 'GET_CERTIFICATEDATA_FAILURE';

// 메세지 내역 > 문자 (구)
export const GET_MESSAGE_HISTORY = 'GET_MESSAGE_HISTORY';
export const GET_MESSAGE_HISTORY_SUCCESS = 'GET_MESSAGE_HISTORY_SUCCESS';
export const GET_MESSAGE_HISTORY_FAILURE = 'GET_MESSAGE_HISTORY_FAILURE';
// 메세지 내역 > 문자 (kt - mono 신)
export const GET_MONO_MESSAGE_HISTORY = 'GET_MONO_MESSAGE_HISTORY';
export const GET_MONO_MESSAGE_HISTORY_SUCCESS =
    'GET_MONO_MESSAGE_HISTORY_SUCCESS';
export const GET_MONO_MESSAGE_HISTORY_FAILURE =
    'GET_MONO_MESSAGE_HISTORY_FAILURE';
// 메세지 내역 > 문자 (kt - mono 신) count
export const GET_MONO_MESSAGE_HISTORY_COUNT = 'GET_MONO_MESSAGE_HISTORY_COUNT';
export const GET_MONO_MESSAGE_HISTORY_COUNT_SUCCESS =
    'GET_MONO_MESSAGE_HISTORY_COUNT_SUCCESS';
export const GET_MONO_MESSAGE_HISTORY_COUNT_FAILURE =
    'GET_MONO_MESSAGE_HISTORY_COUNT_FAILURE';
// 메세지 내역 > 문자 (kt - mono 신) 예약 내역 삭제
export const DELETE_RESERVED_MONO_MESSAGE = 'DELETE_RESERVED_MONO_MESSAGE';
export const DELETE_RESERVED_MONO_MESSAGE_SUCCESS =
    'DELETE_RESERVED_MONO_MESSAGE_SUCCESS';
export const DELETE_RESERVED_MONO_MESSAGE_FAILURE =
    'DELETE_RESERVED_MONO_MESSAGE_FAILURE';
export const CLEAR_DELETE_RESERVED_MONO_MESSAGE_STATUS =
    'CLEAR_DELETE_RESERVED_MONO_MESSAGE_STATUS';

// 메세지 내역 > 운톡 푸쉬 알림
export const GET_PUSH_NOTIFICATION_HISTORY = 'GET_PUSH_NOTIFICATION_HISTORY';
export const GET_PUSH_NOTIFICATION_HISTORY_SUCCESS =
    'GET_PUSH_NOTIFICATION_HISTORY_SUCCESS';
export const GET_PUSH_NOTIFICATION_HISTORY_FAILURE =
    'GET_PUSH_NOTIFICATION_HISTORY_FAILURE';
// 메세지 내역 > 알림톡
export const GET_KAKAO_ALIM_TALK_HISTORY = 'GET_KAKAO_ALIM_TALK_HISTORY';
export const GET_KAKAO_ALIM_TALK_HISTORY_SUCCESS =
    'GET_KAKAO_ALIM_TALK_HISTORY_SUCCESS';
export const GET_KAKAO_ALIM_TALK_HISTORY_FAILURE =
    'GET_KAKAO_ALIM_TALK_HISTORY_FAILURE';
// 메세지 내역 > 알림톡 count
export const GET_KAKAO_ALIM_TALK_COUNT = 'GET_KAKAO_ALIM_TALK_COUNT';
export const GET_KAKAO_ALIM_TALK_COUNT_SUCCESS =
    'GET_KAKAO_ALIM_TALK_COUNT_SUCCESS';
export const GET_KAKAO_ALIM_TALK_COUNT_FAILURE =
    'GET_KAKAO_ALIM_TALK_COUNT_FAILURE';

// 카카오 템플릿 가져오기
export const GET_KAKAO_ALIM_TEMPLATES = 'GET_KAKAO_ALIM_TEMPLATES';
export const GET_KAKAO_ALIM_TEMPLATES_SUCCESS =
    'GET_KAKAO_ALIM_TEMPLATES_SUCCESS';
export const GET_KAKAO_ALIM_TEMPLATES_FAILURE =
    'GET_KAKAO_ALIM_TEMPLATES_FAILURE';

export const MODIFY_AUTOMESSAGE = 'MODIFY_AUTOMESSAGE';
export const MODIFY_AUTOMESSAGE_SUCCESS = 'MODIFY_AUTOMESSAGE_SUCCESS';
export const MODIFY_AUTOMESSAGE_FAILURE = 'MODIFY_AUTOMESSAGE_FAILURE';

export const DELETE_AUTOMESSAGE = 'DELETE_AUTOMESSAGE';
export const DELETE_AUTOMESSAGE_SUCCESS = 'DELETE_AUTOMESSAGE_SUCCESS';
export const DELETE_AUTOMESSAGE_FAILURE = 'DELETE_AUTOMESSAGE_FAILURE';

export const CREATE_AUTOMESSAGE = 'CREATE_AUTOMESSAGE';
export const CREATE_AUTOMESSAGE_SUCCESS = 'CREATE_AUTOMESSAGE_SUCCESS';
export const CREATE_AUTOMESSAGE_FAILURE = 'CREATE_AUTOMESSAGE_FAILURE';

/*ACTION 등록 */
/*인증된 data 가져오는 api */
export const getCertificateDataAction = (data) => ({
    type: GET_CERTIFICATEDATA,
    data,
});

/* 자동알림 설정 가져오는 Action */
export const getAutoMessageSettingAction = (data) => ({
    type: GET_AUTOMESSAGE,
    data,
});

/** 메세지 내역을 불러오는 Action (구) */
export const getMessageHistoryAction = (data) => {
    return {
        type: GET_MESSAGE_HISTORY,
        data,
    };
};

/** 메세지 내역을 불러오는 Action (kt - mono 신)*/
export const getMonoMessageHistoryAction = ({ params, type }) => {
    return {
        type: GET_MONO_MESSAGE_HISTORY,
        data: {
            params,
            type,
        },
    };
};

/** 메세지 내역 count을 불러오는 Action (kt - mono 신)*/
export const getMonoMessageHistoryCountAction = ({ params, type }) => {
    return {
        type: GET_MONO_MESSAGE_HISTORY_COUNT,
        data: {
            params,
            type,
        },
    };
};

/** 메세지 내역 > 문자 (kt - mono 신) 예약 내역 삭제 Action */
export const deleteReservedMonoMessageAction = (data) => ({
    type: DELETE_RESERVED_MONO_MESSAGE,
    data,
});

/** 푸시 알림 내역을 불러오는 Action */
export const getPushNotificationHistoryAction = (data) => {
    return {
        type: GET_PUSH_NOTIFICATION_HISTORY,
        data,
    };
};

/** 알림톡 내역을 불러오는 Action */
export const getKakaoAlimTalkHistoryAction = ({ params, type }) => {
    return {
        type: GET_KAKAO_ALIM_TALK_HISTORY,
        data: {
            params,
            type,
        },
    };
};

/** 알림톡 count을 불러오는 Action */
export const getKakaoAlimTalkCountAction = ({ params, type }) => {
    return {
        type: GET_KAKAO_ALIM_TALK_COUNT,
        data: {
            params,
            type,
        },
    };
};

/** 알림톡 templates를 불러오는 Action */
export const getKakaoTemplatesAction = () => {
    return {
        type: GET_KAKAO_ALIM_TEMPLATES,
    };
};

/* 자동알림 설정 수정 ACTION */
export const modifyAutoMessageSettigAction = (data) => ({
    type: MODIFY_AUTOMESSAGE,
    data,
});

/** 자동문자 설정 삭제 Action */
export const deleteAutoMessageSettingAction = (data) => ({
    type: DELETE_AUTOMESSAGE,
    data,
});

/** 자동문자 설정 삭제 clear Action */
export const clearDeleteReservedMonoMessageStatusAction = () => ({
    type: CLEAR_DELETE_RESERVED_MONO_MESSAGE_STATUS,
});

export const createAutoMessageAction = (data) => ({
    type: CREATE_AUTOMESSAGE,
    data,
});

// 커스텀 정렬 함수: 국문-영문-숫자-기호 순서
const customSort = (a, b) => {
    const cleanA = a.trim();
    const cleanB = b.trim();

    const getCharType = (char) => {
        if (/[ㄱ-ㅎ]/.test(char)) return 1; // 초성 (ㄱ-ㅎ)
        if (/[가-힣]/.test(char)) return 2; // 완성형 한글
        if (/[A-Za-z]/.test(char)) return 3; // 영문
        if (/[0-9]/.test(char)) return 4; // 숫자
        return 5; // 기호
    };

    const typeA = getCharType(cleanA[0]);
    const typeB = getCharType(cleanB[0]);

    if (typeA !== typeB) {
        return typeA - typeB;
    }

    // 같은 타입일 때
    if (typeA === 1 || typeA === 2) {
        // 초성 또는 완성형 한글
        return cleanA.localeCompare(cleanB, 'ko');
    } else if (typeA === 3) {
        // 영문 (대문자 우선)
        return cleanA.localeCompare(cleanB, 'en', { caseFirst: 'upper' });
    } else {
        // 숫자, 기호
        return cleanA.localeCompare(cleanB, undefined, { numeric: true });
    }
};

export const initialState = {
    getCertificateDataLoading: false,
    getCertificateDataDone: false,
    getCertificateDataError: false,
    certificateData: [],

    getAutonMessageSettingLoading: false,
    getAutoMessageSettingDone: false,
    getAutoMessageSettingError: false,
    customerRelativeSettingList: [],
    productRelativeSettingList: [],
    reservationRelativeOptionList: [],

    // 메세지 내역 (구)
    getMessageHistoryLoading: false,
    getMessageHistoryDone: false,
    getMessageHistoryError: false,
    // 메세지 내역 (신)
    getMonoMessageHistoryLoading: false,
    getMonoMessageHistoryDone: false,
    getMonoMessageHistoryError: false,

    getMonoMessageHistoryCountLoading: false,
    getMonoMessageHistoryCountDone: false,
    getMonoMessageHistoryCountError: false,

    getPushNotificationHistoryLoading: false,
    getPushNotificationHistoryDone: false,
    getPushNotificationHistoryError: false,

    getKakaoAlimTalkHistoryLoading: false,
    getKakaoAlimTalkHistoryDone: false,
    getKakaoAlimTalkHistoryError: false,

    getKakaoAlimTalkCountLoading: false,
    getKakaoAlimTalkCountDone: false,
    getKakaoAlimTalkCountError: false,

    getKakaoAlimTalkTemplatesLoading: false,
    getKakaoAlimTalkTemplatesDone: false,
    getKakaoAlimTalkTemplatesError: false,

    reservedSmsList: null,
    reservedLmsList: null,
    reservedMessageList: null,

    sendedSmsList: null,
    sendedLmsList: null,
    sendedMmsList: null,
    pushNotificationList: null,
    sendedMessageList: null,
    kakaoAlimTalkList: null,
    kakaoAlimTalkCount: null,
    monoMessageList: null,
    monoMessageCount: null,

    kakaoAlimTalkTemplates: [],

    deleteReservedMonoMessageLoading: false,
    deleteReservedMonoMessageDone: false,
    deleteReservedMonoMessageError: false,

    modifyAutoMessageLoading: false,
    modifyAutoMessageDone: false,
    modifyAutoMessageError: false,

    deleteAutoMessageLoading: false,
    deleteAutoMessageDone: false,
    deleteAutoMessageError: false,

    createAutoMessageLoading: false,
    createAutoMessageDone: false,
    createAutoMessageError: false,
};

const messageReducer = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case GET_CERTIFICATEDATA:
                draft.getCertificateDataDone = false;
                draft.getCertificateDataError = null;
                draft.getCertificateDataLoading = true;
                break;
            case GET_CERTIFICATEDATA_SUCCES:
                /* 승인된 번호만 필터링 */
                let _certificateData = action.data.filter((data) => {
                    return data.status === 1;
                });
                draft.certificateData = _certificateData;
                draft.getCertificateDataDone = true;
                draft.getCertificateDataError = false;
                break;
            case GET_CERTIFICATEDATA_FAILURE:
                draft.getCertificateDataError = action.error;
                draft.getCertificateDataLoading = false;
                break;

            case GET_AUTOMESSAGE:
                draft.getAutoMessageSettingDone = false;
                draft.getAutoMessageSettingError = null;
                draft.getAutonMessageSettingLoading = true;
                break;
            case GET_AUTOMESSAGE_SUCCES:
                /* 고객 관련 필터링 */
                draft.customerRelativeSettingList = action.data.filter(
                    (data) =>
                        data.function_type === 'CUSTOMER_REBUY_TICKET_ALARM' ||
                        data.function_type === 'CUSTOMER_BIRTHDAY_ALARM' ||
                        data.function_type === 'CUSTOMER_NON_ATTENDANCE' ||
                        data.function_type ===
                            'CUSTOMER_FIRST_BUY_TICKET_ALARM' ||
                        data.function_type === 'NEW_CUSTOMER_CREATED' ||
                        data.function_type ===
                            'CUSTOMER_BUY_RENTAL_TICKET_ALARM' ||
                        data.function_type === 'CUSTOMER_COUPON_EXPIRE_ALARM' ||
                        data.function_type === 'CUSTOMER_CONTRACT_DONE_ALARM' ||
                        data.function_type === 'CUSTOMER_SEGMENT_ENTRY_ALARM' ||
                        data.function_type === 'ACTIVE_CUSTOMER_ALARM' ||
                        data.function_type === 'INACTIVE_CUSTOMER_ALARM' ||
                        data.function_type === 'CUSTOMER_ATTENDANCE' ||
                        data.function_type ===
                            'CUSTOMER_BUY_RENTAL_SPORTS_TICKET_ALARM' ||
                        data.function_type ===
                            'CUSTOMER_BUY_RENTAL_LOCKER_TICKET_ALARM' ||
                        data.function_type ===
                            'SMART_DAILY_LOCKER_ASSIGNMENT' ||
                        data.function_type ===
                            'PERIODIC_LOCKER_ASSIGNMENT_ALARM',
                );
                draft.customerRelativeSettingList =
                    draft.customerRelativeSettingList
                        .map((data) => {
                            return { ...data, related: 'customer' };
                        })
                        .sort((a, b) => customSort(a.name, b.name));

                /* 상품 관련 필터링 */
                draft.productRelativeSettingList = action.data.filter(
                    (data) =>
                        data.function_type === 'CUSTOMER_HOLDING_NEW_ALARM' ||
                        data.function_type ===
                            'CUSTOMER_HOLDING_EXPIRE_ALARM' ||
                        data.function_type === 'MEMBER_TICKET_EXPIRE_ALARM' ||
                        data.function_type === 'LESSON_TICKET_EXPIRE_ALARM' ||
                        data.function_type === 'LESSON_PROGRAM_EXPIRE_ALARM' ||
                        data.function_type === 'RENTAL_PROGRAM_EXPIRE_ALARM' ||
                        data.function_type === 'FACILITY_TICKET_EXPIRE_ALARM' ||
                        data.function_type ===
                            'ENTRY_TICKET_EXPIRE_DATE_ALARM' ||
                        data.function_type === 'CLASS_TICKET_EXPIRE_ALARM' ||
                        data.function_type === 'LOCKER_EXPIRE_ALARM' ||
                        data.function_type === 'SPORTS_EXPIRE_ALARM' ||
                        data.function_type ===
                            'MEMBER_TICKET_EXPIRE_DATE_ALARM' ||
                        data.function_type ===
                            'LESSON_TICKET_EXPIRE_DATE_ALARM' ||
                        data.function_type ===
                            'LESSON_PROGRAM_EXPIRE_DATE_ALARM' ||
                        data.function_type ===
                            'RENTAL_PROGRAM_EXPIRE_DATE_ALARM' ||
                        data.function_type ===
                            'FACILITY_TICKET_EXPIRE_DATE_ALARM' ||
                        data.function_type === 'ENTRY_TICKET_EXPIRE_ALARM' ||
                        data.function_type ===
                            'CLASS_TICKET_EXPIRE_DATE_ALARM' ||
                        data.function_type === 'LOCKER_EXPIRE_DATE_ALARM' ||
                        data.function_type === 'RENTAL_EXPIRE_DATE_ALARM' ||
                        data.function_type === 'SPORTS_EXPIRE_DATE_ALARM' ||
                        data.function_type ===
                            'MEMBER_TICKET_EXPIRE_ALARM_WITH_MILEAGE' ||
                        data.function_type ===
                            'LESSON_TICKET_EXPIRE_ALARM_WITH_MILEAGE' ||
                        data.function_type ===
                            'LOCKER_EXPIRE_ALARM_WITH_MILEAGE' ||
                        data.function_type ===
                            'SPORTS_EXPIRE_ALARM_WITH_MILEAGE' ||
                        data.function_type ===
                            'MEMBER_TICKET_EXPIRE_DATE_ALARM_WITH_MILEAGE' ||
                        data.function_type ===
                            'LESSON_TICKET_EXPIRE_DATE_ALARM_WITH_MILEAGE',
                );
                draft.productRelativeSettingList =
                    draft.productRelativeSettingList
                        .map((data) => {
                            return { ...data, related: 'product' };
                        })
                        .sort((a, b) => customSort(a.name, b.name));

                /* 예약 관련 필터링 */
                draft.reservationRelativeOptionList = action.data.filter(
                    (data) =>
                        data.function_type === 'LESSON_BOOK_ALARM' ||
                        data.function_type === 'FACILITY_BOOK_ALARM' ||
                        data.function_type === 'LESSON_CANCEL_BOOK_ALARM' ||
                        data.function_type === 'FACILITY_CANCEL_BOOK_ALARM' ||
                        data.function_type === 'FACILITY_CHANGE_BOOK_ALARM',
                );
                draft.reservationRelativeOptionList =
                    draft.reservationRelativeOptionList
                        .map((data) => {
                            return { ...data, related: 'reservation' };
                        })
                        .sort((a, b) => customSort(a.name, b.name));

                // console.log(
                //   "customerRelativeSettingList",
                //   draft.customerRelativeSettingList
                // );
                // console.log("product", draft.productRelativeSettingList);
                draft.getAutoMessageSettingDone = true;
                draft.getAutoMessageSettingError = false;
                break;
            case GET_AUTOMESSAGE_FAILURE:
                draft.getAutoMessageSettingError = action.error;
                draft.getAutonMessageSettingLoading = false;
                break;
            case GET_MESSAGE_HISTORY:
                draft.reservedMessageList = [];
                draft.reservedSmsList = [];
                draft.reservedLmsList = [];
                draft.sendedMessageList = [];
                draft.sendedLmsList = [];
                draft.sendedSmsList = [];
                draft.getMessageHistoryDone = false;
                draft.getMessageHistoryError = null;
                draft.getMessageHistoryLoading = true;
                break;
            case GET_MESSAGE_HISTORY_SUCCESS:
                // draft.mmsList = action.data.mms.map((mms) =>
                //   Object.assign(mms, { TYPE: "MMS" })
                // );
                // draft.lmsList = action.data.sms.filter((lms) =>
                //   calculateGreaterthan(lms, lms.TR_MSG, 90)
                // );
                // draft.smsList = action.data.sms.filter((sms) =>
                //   calculateLessthan(sms, sms.TR_MSG, 90)
                // );

                // console.log(action.data);

                draft.reservedSmsList = action.data.sms
                    .filter((sms) => sms.is_reserved ?? false)
                    .sort((a, b) => {
                        const dateA = new Date(a.submit_time);
                        const dateB = new Date(b.submit_time);
                        return dateA - dateB;
                    });
                draft.reservedLmsList = action.data.lms
                    .filter((lms) => lms.is_reserved ?? false)
                    .sort((a, b) => {
                        const dateA = new Date(a.submit_time);
                        const dateB = new Date(b.submit_time);
                        return dateA - dateB;
                    });

                draft.reservedMessageList = [
                    ...draft.reservedSmsList,
                    ...draft.reservedLmsList,
                ];
                draft.reservedMessageList = draft.reservedMessageList.sort(
                    (a, b) => {
                        const dateA = new Date(a.submit_time);
                        const dateB = new Date(b.submit_time);
                        return dateA - dateB;
                    },
                );

                // console.log('draft.reservedMessageList', draft.reservedMessageList);

                draft.sendedLmsList = action.data.lms
                    .filter((lms) => !lms.is_reserved ?? false)
                    .sort((a, b) => {
                        const dateA = new Date(a.RSLTDATE || a.submit_time);
                        const dateB = new Date(b.RSLTDATE || b.submit_time);
                        return dateB - dateA;
                    });
                draft.sendedSmsList = action.data.sms
                    .filter((sms) => !sms.is_reserved ?? false)
                    .sort((a, b) => {
                        const dateA = new Date(a.TR_RSLTDATE || a.submit_time);
                        const dateB = new Date(b.TR_RSLTDATE || b.submit_time);
                        return dateB - dateA;
                    });
                draft.sendedMessageList = [
                    ...draft.sendedSmsList,
                    ...draft.sendedLmsList,
                    // ...draft.mmsList,
                ];
                draft.sendedMessageList = draft.sendedMessageList.sort(
                    (a, b) => {
                        const dateA = new Date(
                            a.RSLTDATE || a.TR_RSLTDATE || a.submit_time,
                        );
                        const dateB = new Date(
                            b.RSLTDATE || b.TR_RSLTDATE || b.submit_time,
                        );
                        return dateB - dateA;
                    },
                );
                // console.log('draft.sendedMessageList', draft.sendedMessageList);
                draft.getMessageHistoryDone = true;
                draft.getMessageHistoryError = false;
                draft.getMessageHistoryLoading = false;
                break;
            case GET_MESSAGE_HISTORY_FAILURE:
                draft.getMessageHistoryError = action.error;
                draft.getMessageHistoryLoading = false;
                break;
            // 메세지 내역 (kt - mono 신)
            case GET_MONO_MESSAGE_HISTORY:
                draft.getMonoMessageHistoryLoading = true;
                draft.getMonoMessageHistoryDone = null;
                draft.getMonoMessageHistoryError = true;
                break;
            case GET_MONO_MESSAGE_HISTORY_SUCCESS:
                draft.monoMessageList = action.data;

                draft.getMonoMessageHistoryLoading = false;
                draft.getMonoMessageHistoryDone = true;
                draft.getMonoMessageHistoryError = false;
                break;
            case GET_MONO_MESSAGE_HISTORY_FAILURE:
                draft.getMonoMessageHistoryError = action.error;
                draft.getMonoMessageHistoryLoading = false;
                break;
            case GET_MONO_MESSAGE_HISTORY_COUNT:
                draft.getMonoMessageHistoryCountLoading = true;
                draft.getMonoMessageHistoryCountDone = null;
                draft.getMonoMessageHistoryCountError = true;
                break;
            case GET_MONO_MESSAGE_HISTORY_COUNT_SUCCESS:
                draft.monoMessageCount = action.data;

                draft.getMonoMessageHistoryCountLoading = false;
                draft.getMonoMessageHistoryCountDone = true;
                draft.getMonoMessageHistoryCountError = false;
                break;
            case GET_MONO_MESSAGE_HISTORY_COUNT_FAILURE:
                draft.getMonoMessageHistoryCountError = action.data;
                draft.getMonoMessageHistoryCountLoading = false;
                break;
            case DELETE_RESERVED_MONO_MESSAGE:
                draft.deleteReservedMonoMessageLoading = true;
                draft.deleteReservedMonoMessageDone = false;
                draft.deleteReservedMonoMessageError = false;
                break;
            case DELETE_RESERVED_MONO_MESSAGE_SUCCESS:
                draft.deleteReservedMonoMessageLoading = false;
                draft.deleteReservedMonoMessageDone = true;
                break;
            case DELETE_RESERVED_MONO_MESSAGE_FAILURE:
                draft.deleteReservedMonoMessageDone = false;
                draft.deleteReservedMonoMessageLoading = false;
                draft.deleteReservedMonoMessageError = action.error;
                break;
            case CLEAR_DELETE_RESERVED_MONO_MESSAGE_STATUS:
                draft.deleteReservedMonoMessageLoading = false;
                draft.deleteReservedMonoMessageDone = false;
                draft.deleteReservedMonoMessageError = false;
                break;
            case GET_PUSH_NOTIFICATION_HISTORY:
                draft.getPushNotificationHistoryLoading = true;
                draft.getPushNotificationHistoryDone = null;
                draft.getPushNotificationHistoryError = true;
                break;
            case GET_PUSH_NOTIFICATION_HISTORY_SUCCESS:
                draft.pushNotificationList = action.data;

                draft.getPushNotificationHistoryLoading = false;
                draft.getPushNotificationHistoryDone = true;
                draft.getPushNotificationHistoryError = false;
                break;
            case GET_PUSH_NOTIFICATION_HISTORY_FAILURE:
                draft.getPushNotificationHistoryError = action.error;
                draft.getPushNotificationHistoryLoading = false;
                break;
            case GET_KAKAO_ALIM_TALK_HISTORY:
                draft.getKakaoAlimTalkHistoryLoading = true;
                draft.getKakaoAlimTalkHistoryDone = null;
                draft.getKakaoAlimTalkHistoryError = true;
                break;
            case GET_KAKAO_ALIM_TALK_HISTORY_SUCCESS:
                draft.kakaoAlimTalkList = action.data;

                draft.getKakaoAlimTalkHistoryLoading = false;
                draft.getKakaoAlimTalkHistoryDone = true;
                draft.getKakaoAlimTalkHistoryError = false;
                break;
            case GET_KAKAO_ALIM_TALK_HISTORY_FAILURE:
                draft.getKakaoAlimTalkHistoryError = action.error;
                draft.getKakaoAlimTalkHistoryLoading = false;
                break;
            case GET_KAKAO_ALIM_TALK_COUNT:
                draft.getKakaoAlimTalkCountLoading = true;
                draft.getKakaoAlimTalkCountDone = null;
                draft.getKakaoAlimTalkCountError = true;
                break;
            case GET_KAKAO_ALIM_TALK_COUNT_SUCCESS:
                draft.kakaoAlimTalkCount = action.data;

                draft.getKakaoAlimTalkCountLoading = false;
                draft.getKakaoAlimTalkCountDone = true;
                draft.getKakaoAlimTalkCountError = false;
                break;
            case GET_KAKAO_ALIM_TALK_COUNT_FAILURE:
                draft.getKakaoAlimTalkCountError = action.data;
                draft.getKakaoAlimTalkCountLoading = false;
                break;
            case GET_KAKAO_ALIM_TEMPLATES:
                draft.getKakaoAlimTalkTemplatesLoading = true;
                draft.getKakaoAlimTalkTemplatesDone = null;
                draft.getKakaoAlimTalkTemplatesError = true;
                break;
            case GET_KAKAO_ALIM_TEMPLATES_SUCCESS:
                draft.kakaoAlimTalkTemplates = action.data;

                draft.getKakaoAlimTalkTemplatesLoading = false;
                draft.getKakaoAlimTalkTemplatesDone = true;
                draft.getKakaoAlimTalkTemplatesError = false;
                break;
            case GET_KAKAO_ALIM_TEMPLATES_FAILURE:
                draft.getKakaoAlimTalkTemplatesError = action.data;
                draft.getKakaoAlimTalkTemplatesLoading = false;
                break;
            case MODIFY_AUTOMESSAGE:
                draft.createAutoMessageDone = false;
                draft.modifyAutoMessageDone = false;
                draft.modifyAutoMessageError = null;
                draft.modifyAutoMessageLoading = true;
                break;
            case MODIFY_AUTOMESSAGE_SUCCESS:
                draft.modifyAutoMessageDone = true;
                draft.modifyAutoMessageError = false;
                draft.modifyAutoMessageLoading = false;
                break;
            case MODIFY_AUTOMESSAGE_FAILURE:
                draft.modifyAutoMessageDone = false;
                draft.modifyAutoMessageError = action.error;
                draft.modifyAutoMessageLoading = false;
                break;

            case DELETE_AUTOMESSAGE:
                draft.deleteAutoMessageLoading = true;
                draft.deleteAutoMessageDone = false;
                draft.deleteAutoMessageError = false;
                break;
            case DELETE_AUTOMESSAGE_SUCCESS:
                draft.deleteAutoMessageLoading = false;
                draft.deleteAutoMessageDone = true;

                draft.customerRelativeSettingList =
                    state.customerRelativeSettingList.filter(
                        (data) =>
                            !(
                                data.auto_message_key ===
                                action.data.auto_message_key
                            ),
                    );

                draft.productRelativeSettingList =
                    state.productRelativeSettingList.filter(
                        (data) =>
                            !(
                                data.auto_message_key ===
                                action.data.auto_message_key
                            ),
                    );

                draft.reservationRelativeOptionList =
                    state.reservationRelativeOptionList.filter(
                        (data) =>
                            !(
                                data.auto_message_key ===
                                action.data.auto_message_key
                            ),
                    );
                break;
            case DELETE_AUTOMESSAGE_FAILURE:
                draft.deleteAutoMessageLoading = false;
                draft.deleteAutoMessageError = true;
                break;

            case CREATE_AUTOMESSAGE:
                draft.modifyAutoMessageDone = false;
                draft.createAutoMessageLoading = true;
                draft.createAutoMessageDone = false;
                draft.createAutoMessageError = false;
                break;
            case CREATE_AUTOMESSAGE_SUCCESS:
                draft.createAutoMessageLoading = false;
                draft.createAutoMessageDone = true;
                break;
            case CREATE_AUTOMESSAGE_FAILURE:
                draft.createAutoMessageDone = false;
                draft.createAutoMessageLoading = false;
                draft.createAutoMessageError = true;
                break;
            default:
                break;
        }
    });
};
export default messageReducer;
